export function setupCalendarFilter() {
    const startDateField = document.getElementById('startDateField');
    const endDateField = document.getElementById('endDateField');
    const typeField = document.getElementById('typeField');
    const eventItems = document.querySelectorAll('.calendar__day,.calendar__item');

    if (
        startDateField != undefined &&
        endDateField != undefined &&
        typeField != undefined &&
        eventItems.length > 0
    ) {
        function filterEvents(updateUrl) {
            const selectedType = typeField.selectedIndex != 0 ? typeField.options[typeField.selectedIndex].value : '';
            const selectedStartDateString = startDateField.value;
            const selectedEndDateString = endDateField.value;

            const startParts = selectedStartDateString.split('.');
            const startDay = parseInt(startParts[0], 10);
            const startMonth = parseInt(startParts[1], 10) - 1;
            const startYear = parseInt(startParts[2], 10);
            const selectedDateStart = new Date(startYear, startMonth, startDay);

            const endParts = selectedEndDateString.split('.');
            const endDay = parseInt(endParts[0], 10);
            const endMonth = parseInt(endParts[1], 10) - 1;
            const endYear = parseInt(endParts[2], 10);
            const selectedDateEnd = new Date(endYear, endMonth, endDay);

            let currentDay = -1;
            let dayEventCounter = 0;

            for (let a = 0, l = eventItems.length; a < l; a++) {
                const eventItem = eventItems[a];

                if (eventItem.classList.contains('calendar__day')) {
                    if (dayEventCounter == 0 && currentDay != -1) {
                        currentDay.classList.add('js-hide');
                    } else if (currentDay != -1) {
                        currentDay.classList.remove('js-hide');
                    }

                    currentDay = eventItem;
                    dayEventCounter = 0;
                }

                if (eventItem.classList.contains('calendar__item')) {
                    const eventTypes = eventItem.getAttribute('data-type');
                    const eventDateStartString = eventItem.getAttribute('data-date-start');
                    const eParts = eventDateStartString.split('.');
                    const eDay = parseInt(eParts[0], 10);
                    const eMonth = parseInt(eParts[1], 10) - 1;
                    const eYear = parseInt(eParts[2], 10);
                    const eventDateStart = new Date(eYear, eMonth, eDay);

                    if (
                        (eventTypes.includes(selectedType) || selectedType == '') &&
                        eventDateStart >= selectedDateStart &&
                        eventDateStart <= selectedDateEnd
                    ) {
                        eventItem.classList.remove('js-hide');
                        dayEventCounter++;
                    } else {
                        eventItem.classList.add('js-hide');
                    }
                }
            }

            if (dayEventCounter == 0 && currentDay != -1) {
                currentDay.classList.add('js-hide');
            } else if (currentDay != -1) {
                currentDay.classList.remove('js-hide');
            }

            if (updateUrl) {
                let pushState = `${location.protocol}//${location.host}${location.pathname}`;
                let parameterAdded = false;

                if (selectedType != '') {
                    pushState += `?type=${selectedType}`;
                    parameterAdded = true;
                }

                history.pushState({}, document.title, pushState);
            }
        }

        let startDate = -1;
        let endDate = -1;

        let checkPikaday = setInterval(function () {
            if (typeof Pikaday != 'undefined') {
                clearInterval(checkPikaday);
                createDateFields();
            }
        }, 10);

        function createDateFields() {
            let defaultDatesSet = false;

            const startDateField = document.getElementById('startDateField');
            const endDateField = document.getElementById('endDateField');

            const updateStartDate = function () {
                startPicker.setStartRange(startDate);
                endPicker.setStartRange(startDate);
                endPicker.setMinDate(startDate);
            };

            const updateEndDate = function () {
                startPicker.setEndRange(endDate);
                startPicker.setMaxDate(endDate);
                endPicker.setEndRange(endDate);
            };

            const startPicker = new Pikaday({
                field: startDateField,
                firstDay: 1,
                i18n: {
                    previousMonth: 'Forrige måned',
                    nextMonth: 'Næste måned',
                    months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                    weekdays: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                    weekdaysShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør']
                },
                toString(date, format) {
                    let day = date.getDate().toString();
                    let month = date.getMonth() + 1;
                    month = month.toString();
                    const year = date.getFullYear();

                    if (day.length == 1) {
                        day = `0${day}`;
                    }

                    if (month.length == 1) {
                        month = `0${month}`;
                    }

                    return `${day}.${month}.${year}`;
                },
                onSelect () {
                    startDate = this.getDate();
                    updateStartDate();

                    if (defaultDatesSet) {
                        filterEvents(true);
                    }
                },
                parse(dateString, format) {
                    const parts = dateString.split('/');
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1;
                    const year = parseInt(parts[2], 10);

                    return new Date(year, month, day);
                }
            });

            const endPicker = new Pikaday({
                field: endDateField,
                firstDay: 1,
                i18n: {
                    previousMonth: 'Forrige måned',
                    nextMonth: 'Næste måned',
                    months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                    weekdays: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                    weekdaysShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør']
                },
                toString(date, format) {
                    let day = date.getDate().toString();
                    let month = date.getMonth() + 1;
                    month = month.toString();
                    const year = date.getFullYear();

                    if (day.length == 1) {
                        day = `0${day}`;
                    }

                    if (month.length == 1) {
                        month = `0${month}`;
                    }

                    return `${day}.${month}.${year}`;
                },
                onSelect () {
                    endDate = this.getDate();
                    updateEndDate();

                    if (defaultDatesSet) {
                        filterEvents(true);
                    }
                },
                parse(dateString, format) {
                    const parts = dateString.split('/');
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1;
                    const year = parseInt(parts[2], 10);

                    return new Date(year, month, day);
                }
            });

            const startEndDate = new Date();
            startEndDate.setMonth(startEndDate.getMonth() + 6);

            startPicker.setDate(new Date());
            endPicker.setDate(startEndDate);

            defaultDatesSet = true;

            const _startDate = startPicker.getDate();
            const _endDate = endPicker.getDate();

            if (_startDate) {
                startDate = _startDate;
                updateStartDate();
            }

            if (_endDate) {
                endDate = _endDate;
                updateEndDate();
            }

            typeField.addEventListener('change',function() {
                filterEvents(true);
            });

            filterEvents(false);
        }
    }
}